import axios, {AxiosResponse} from "axios";
import {PollingResult} from "./mfaPushService.types";

export interface PollingHandler {
  onSuccess: (data: any) => void;
  onError: (error: any) => void;
}

export interface ConfirmMfaPushLoginHandler {
  onSuccess: (data: any) => void;
  onError: (error: any) => void;
}

export const pollTicket = async (ticketId: string, userId: string | undefined, pollingHandler: PollingHandler) => {
  let pollingResponse: AxiosResponse;
  try {
    pollingResponse = await axios.get("/janus/janus-rest/public/mfa/push/v100/sign-in/ticket/" + userId + "/" + ticketId);
  } catch (error: any) {
    pollingHandler.onError(error);
    return;
  }
  pollingHandler.onSuccess(pollingResponse.data);
}

export const confirmMfaPushLogin = async (confirmedPollingTicket: PollingResult, rememberDevice: boolean, confirmMfaPushLoginHandler: ConfirmMfaPushLoginHandler) => {
  let response: AxiosResponse;
  try {
    response = await axios.post("/grld-public/login/token-authorize-ticket/" + confirmedPollingTicket.loginTicket, {userId: confirmedPollingTicket.userId, rememberDevice: rememberDevice});
  } catch (error: any) {
    confirmMfaPushLoginHandler.onError(error);
    return;
  }
  confirmMfaPushLoginHandler.onSuccess(response);
}


